import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, map, Observable, take } from 'rxjs';
import { UserState } from '../../user-management/state/user-management.state';
import { IUser } from '@cod-monorepo/interfaces';

@Injectable({
    providedIn: 'root'
})
export class UserGuard {
    user$: Observable<IUser | undefined> = inject(Store).select(UserState.user);

    public canLoad(): Observable<boolean> {
        return this.user$.pipe(
            filter(user => !!user),
            take(1),
            map(() => true)
        );
    }
}

export const canActivateUser: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    userGuard = inject(UserGuard)
) => userGuard.canLoad();
